import React, { useState } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  SelectChangeEvent,
} from '@mui/material';
import { ESex } from '../../hooks/auth/models';
import { useTranslationContext } from '../../hooks/translations/translationsProvider';
import { GREEN_LOGO, GREEN_MAIN, WHITE } from '../../theme/colors';

interface SexSelectProps {
  value: string | ESex;
  onChange?: (value: string) => void;
  disable?: boolean;
}

const SexSelect: React.FC<SexSelectProps> = ({
  value,
  onChange,
  disable = false
}) => {
  const [sexError, setSexError] = useState(false);
  const { t } = useTranslationContext();

  const handleChange = (event: SelectChangeEvent<string>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const handleBlur = () => {
    if (value !== ESex.Male && value !== ESex.Female) {
      setSexError(true);
    } else {
      setSexError(false);
    }
  };

  return (
    <FormControl
      fullWidth
      variant="outlined"
      error={sexError}
      disabled={disable}
    >
      <InputLabel
        id="sex-select-label"
        sx={{
          fontSize: '1rem',
          color: GREEN_MAIN,          
          backgroundColor: WHITE,
          '&.Mui-focused': {
            color: GREEN_MAIN,
          },
          "&.MuiInputLabel-root":{
            top:-5,
            left: -2,
          }
        }}
      >
        {!sexError ? t("Sesso") : t("Errore")}
      </InputLabel>

      <Select
        labelId="sex-select-label"
        value={value.toString()}
        onChange={handleChange}
        onBlur={handleBlur}
        size="small"
        sx={{
          height:47,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: GREEN_LOGO,
            color: GREEN_MAIN,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: GREEN_LOGO,
            color: GREEN_MAIN,
          },
          '& .MuiOutlinedInput-input': {
            padding: '12px 12px',
            lineHeight: 1.4,
            color: "grey",
            fontSize: '1rem',
          },
          fontSize: '1rem',
          // marginTop: "16px",
          // marginBottom: "8px",
          color: GREEN_MAIN,
        }}
      >
        <MenuItem value={ESex.Male} sx={{ fontSize: '1em' }}>
          M
        </MenuItem>
        <MenuItem value={ESex.Female} sx={{ fontSize: '1em' }}>
          F
        </MenuItem>
      </Select>

      {sexError && (
        <FormHelperText>{t("Seleziona un sesso valido")}</FormHelperText>
      )}
    </FormControl>
  );
};

export default SexSelect;
